import React from 'react';
import {Select} from 'components/antd';
import useSearchParams from '../../useSearchParams';
import options from 'helpers/countOptions';

const MailCampaignOpenCountFilter = () => {
  const {query, setQuery} = useSearchParams();

  return (
    <Select
      dropdownMatchSelectWidth={false}
      mode="multiple"
      allowClear
      value={query.mailCampaignOpenCounts || []}
      onChange={(value) => setQuery({page: 1, mailCampaignOpenCounts: value})}>
      {options.map((option) => (
        <Select.Option
          value={option.value}
          key={option.value}
          label={option.text}>
          {option.text}
        </Select.Option>
      ))}
    </Select>
  );
};

export default MailCampaignOpenCountFilter;
